export const redirect = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete('redirect_url');
  url.searchParams.set('fromSellerLanding', '');

  window.location.assign(`/?${url.searchParams.toString()}`);
};
